import { withInstall } from "../../utils/index"
import scCascaderNew from "./component/index.vue"
export type * from "./component/type"

export const ScCascaderNew = withInstall(scCascaderNew)
